import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DictionaryEntryModel, DictionaryKey, HxDictionaryService, HxUiLabelPipe } from 'hx-services';
import { concat, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';


@Component({
    selector: 'app-spend-category-search',
    templateUrl: './spend-category-search.component.html',
    styleUrls: ['./spend-category-search.component.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgSelectComponent, FormsModule, NgLabelTemplateDirective, NgOptionTemplateDirective, TranslocoPipe, HxUiLabelPipe]
})
export class SpendCategorySearchComponent implements OnInit, OnChanges {
  @Output() update = new EventEmitter<DictionaryEntryModel | undefined>();
  @Input() code?: string;
  @Input() disabled = false;
  @Input() key = DictionaryKey.spendings;

  itemLoading = false;
  items: DictionaryEntryModel[] = [];
  itemInput$ = new Subject<string>();
  selected: string | string[] | undefined;

  constructor(
    private dictionaryService: HxDictionaryService,
  ) {
  }

  ngOnInit() {
    this.loadItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['code']) {
      this.selected = this.code;
      this.loadItems();
    }
  }

  trackByFn(item: DictionaryEntryModel) {
    return item.code;
  }

  private loadItems() {
    const initItems = (categories: DictionaryEntryModel[]) => {
      concat(
        of(categories), // default items
        this.itemInput$.pipe(
          debounceTime(500),
          distinctUntilChanged(),
          filter(term => {
            const isOk: boolean = (term ?? '').trim() !== '';
            this.itemLoading = isOk;
            return isOk;
          }),
          switchMap(term => this.dictionaryService.getEntries({ key: this.key, query: term, hierarchy: false})),
          tap(() => this.itemLoading = false),
          map(items => items),
          catchError(() => of([] as DictionaryEntryModel[])), // empty list on error
        )
      ).subscribe(items => this.items = items);
    };
    if (this.code) {
      this.dictionaryService.getEntryByCode(this.code).then(user => initItems([user]));
    } else {
      initItems([]);
    }
  }

  onCategoryChanged(category?: DictionaryEntryModel) {
    if (category) {
      this.update.emit(category);
    } else {
      this.update.emit(undefined);
    }
  }
}
